export default __webpack_public_path__ + "static/media/OrderStatus_2.898fde4e.svg";